import { type RuleRegistry } from '../types';

import { commonRulesValidationRule } from './commonRules';
import { ActuateGripperValidation } from './steps/ActuateGripper';
import { AddOffsetValidation } from './steps/AddOffset';
import { AnticipatePayloadValidation } from './steps/AnticipatePayload';
import { AntigravityValidation } from './steps/Antigravity';
import { ArcValidation } from './steps/Arc';
import { CallSubroutineValidation } from './steps/CallSubroutine';
import { CaptureValidation } from './steps/Capture';
import { ClassifyValidation } from './steps/Classify';
import { CNCOperateAutodoorValidation } from './steps/CNCOperateAutodoor';
import { CNCOperateWorkholdingValidation } from './steps/CNCOperateWorkholding';
import { CodeBlockValidation } from './steps/CodeBlock';
import { CreateDemonstrationValidation } from './steps/CreateDemonstration';
import { CreateRecordingValidation } from './steps/CreateRecording';
import { DecoratorValidation } from './steps/Decorator';
import { ElseIfValidation } from './steps/ElseIf';
import { EnableGripperValidation } from './steps/EnableGripper';
import { ExpressionReferencesValidation } from './steps/ExpressionReferences';
import { HaasEndpointValidation } from './steps/HaasEndpoint';
import { IfValidation } from './steps/If';
import { LocateValidation } from './steps/Locate';
import { LoopValidation } from './steps/Loop';
import { LoopControlValidation } from './steps/LoopControl';
import { MoveArmToValidation } from './steps/MoveArmTo';
import { MoveArmToV2Validation } from './steps/MoveArmToV2';
import { NetworkRequestValidation } from './steps/NetworkRequest';
import { OperateEquipmentValidation } from './steps/OperateEquipment';
import { PressButtonValidation } from './steps/PressButton';
import { PushModeValidation } from './steps/PushMode';
import { RotaryWeldValidation } from './steps/RotaryWeld';
import { RunDemonstrationValidation } from './steps/RunDemonstration';
import { RunInBackgroundValidation } from './steps/RunInBackground';
import { RunInspectSkillValidation } from './steps/RunInspectSkill';
import { RunLocateSkillValidation } from './steps/RunLocateSkill';
import { RunSkillValidation } from './steps/RunSkill';
import { SafetyIOOutputsValidation } from './steps/SafetyIOOutputs';
import { SamplePositioningApproachValidation } from './steps/SamplePositioningApproach';
import { SetActiveTooltipValidation } from './steps/SetActiveTooltip';
import { SetEnvironmentVariableValidation } from './steps/SetEnvironmentVariable';
import { SetIOValidation } from './steps/SetIO';
import { StepConfiguredValidation } from './steps/StepConfigured';
import { SuppressedValidation } from './steps/Suppressed';
import { TeleopValidation } from './steps/Teleop';
import { TriggerFaultValidation } from './steps/TriggerFault';
import { UpdateVisualizationValidation } from './steps/UpdateVisualization';
import { VariableReferencesSuppressedStepValidation } from './steps/VariableReferencesSuppressedStep';
import { WaitValidation } from './steps/Wait';
import { WaitForConfirmationValidation } from './steps/WaitForConfirmation';
import { WaypointValidation } from './steps/Waypoint';
import { WeldValidation } from './steps/Weld';
import { subroutineGraphErrorsValidationRule } from './subroutineGraphErrors';

export const defaultRuleRegistry: RuleRegistry = [
  // Common structural and global rules
  commonRulesValidationRule,
  subroutineGraphErrorsValidationRule,
  // Cross-cutting step rules (no stepKinds filter — applies to all steps)
  DecoratorValidation,
  StepConfiguredValidation,
  ExpressionReferencesValidation,
  // Native step rules
  ActuateGripperValidation,
  AddOffsetValidation,
  AntigravityValidation,
  AnticipatePayloadValidation,
  ElseIfValidation,
  EnableGripperValidation,
  IfValidation,
  WaypointValidation,
  ArcValidation,
  CallSubroutineValidation,
  CaptureValidation,
  ClassifyValidation,
  CreateRecordingValidation,
  CreateDemonstrationValidation,
  LocateValidation,
  LoopControlValidation,
  LoopValidation,
  MoveArmToValidation,
  MoveArmToV2Validation,
  OperateEquipmentValidation,
  CNCOperateAutodoorValidation,
  CNCOperateWorkholdingValidation,
  HaasEndpointValidation,
  SafetyIOOutputsValidation,
  RotaryWeldValidation,
  WeldValidation,
  SetActiveTooltipValidation,
  SetEnvironmentVariableValidation,
  SetIOValidation,
  NetworkRequestValidation,
  CodeBlockValidation,
  RunDemonstrationValidation,
  RunSkillValidation,
  RunInspectSkillValidation,
  RunLocateSkillValidation,
  SamplePositioningApproachValidation,
  RunInBackgroundValidation,
  PressButtonValidation,
  PushModeValidation,
  TeleopValidation,
  TriggerFaultValidation,
  UpdateVisualizationValidation,
  WaitValidation,
  WaitForConfirmationValidation,
  ...SuppressedValidation,
  VariableReferencesSuppressedStepValidation,
];
